export const CALENDAR_BACKGROUND_SYNC_MS = 60 * 60 * 1000

export const CALENDAR_NOTICE_DISMISS_MS = 8000
